import KiteConnectRedirect from '../pages/KiteConnectRedirect';
import { Route, Routes } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Home from '../pages/Home';
import KCOrders from '../pages/kc/KCOrders';
import Broker from '../pages/broker/Broker';
import AddBrokerForm from '../pages/broker/AddBrokerForm';
import Registration from '../pages/Registration';
import Login from '../pages/Login';
import UnauthLayout from '../layouts/UnauthLayout';
import PrivateRoute from './PrivateRoute';
import AuthLayout from '../layouts/AuthLayout';
import PublicRoute from './PublicRoute';
import UserProfile from '../pages/profile/UserProfile';
const AppRouting = () => {
    return (
        <Router>
            <Routes>
                {/* Unauthenticated routes */}
                <Route element={<PublicRoute><UnauthLayout /></PublicRoute>}>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/registration" element={<Registration />} />
                </Route>
                {/* Authenticated routes */}
                <Route element={<PrivateRoute><AuthLayout /></PrivateRoute>}>
                    <Route path="/profile" element={<UserProfile />} />
                    <Route path="/kc/orders" element={<KCOrders />} />
                    <Route path="/redirect" element={<KiteConnectRedirect />} />
                    <Route path="/broker" element={<Broker />} />
                    <Route path="/broker/add" element={<AddBrokerForm />} />
                {/* Add more routes here as needed */}
                </Route>
            </Routes>
        </Router>
    );
};

export default AppRouting;
